module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAANCAYAAAE1YMXLAAAAAXNSR0IArs4c6QAAANRJREFUOBGtkjEOwjAMRQviClyIBRYmJhASggkmbsQRuAMzt0Bi4QCAEG14ruSSpg21Si19Jbb//26SJoktnHObEpPCulRoTFBcKiSK70qRQh+4ukZeq7VSNs0n2GseW3uQbjSHMUJQvxa5dYIvGCHaFYXYBtIUxE+uQjgLkGr+a5WDNjuqA9y51TnXQLZ9szfBdhsqkJUpE/AAEku/13qP0Qy8QAa2rY08odz2ivwA5C8+gSPoIs4DXLLAyf60gTBIvz6coPNrCYblDzpm0B1I/PWgH7/+mS213tFVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Arrow-Left.png
// module id = 4wOa
// module chunks = 1